import React, { useEffect, useState } from 'react'
import { rbsApi } from '../api/rbsApi'
import { useTranslation } from 'react-i18next';

export const useAxiosPost = (
    url,
    object,
    handleFormSubmitted = null
) => {

    const [state, setState] = useState({
        data: null,
        isLoading: false,
        error: null
    });

    const postAxios = async () => {

        setState(prev => ({
            ...prev,
            isLoading: true
        }));

        try {

            const { data } = await rbsApi.post(url, object);

            setState({
                data,
                isLoading: false,
                error: null
            });

        } catch (error) {

            setState({
                data: null,
                isLoading: false,
                error
            });

        } finally {

            if (handleFormSubmitted) {
                handleFormSubmitted(false);
            }

        }
    };

    useEffect(() => {

        if (!url) return;

        postAxios();

    }, [url]);

    return state;
}

export const useAxiosPost2 = (url, object, handleFormSubmitted) => {

    const [t, i18n] = useTranslation("global");

    const [state, setState] = useState(
        {
            data2: null,
            isLoading2: true,
            error2: null
        }
    )

    const postAxios = async () => {
        setState({
            ...state,
            isLoading2: true
        })

        try {
            const { data } = rbsApi.post(url, object)
                .then(() => {
                    setState(
                        {
                            data2: data,
                            isLoading2: false,
                            error2: null,
                        }
                    );

                })
                .catch(error => {
                    setState({
                        data2: null,
                        isLoading2: false,
                        error2: error,
                    });
                });

        } catch (error) {
            setState({
                data2: null,
                isLoading2: false,
                error2: error,
            });
        } finally {
            handleFormSubmitted(false); // Llama a la función de callback para restablecer formSubmitted
        }


    }

    useEffect(() => {
        if (!url) {
            setState({
                data2: null,
                isLoading2: false,
                error2: null,
            });

            return;
        };
        postAxios();
    }, [url])

    return {
        data2: state.data,
        isLoading2: state.isLoading,
        error2: state.error
    }
}
